import { put, call, take, fork } from 'redux-saga/effects'
import { courseEditService } from '../../api/course'
import { courseEditSuccess } from '../../reducers/course/action'
import { COURSE_EDIT } from '../../reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* assignmentEditFlow(payload) {
  try {
    const { entity, callback } = payload
    const response = yield call(courseEditService, entity)

    yield put(courseEditSuccess(response.data))
    yield put(operationSuccess())
    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* assignmentEditWatcher() {
  while (true) {
    const action = yield take(COURSE_EDIT)
    const { payload } = action

    yield fork(generalSaga, assignmentEditFlow, payload)
  }
}
